import React, { Component } from 'react';
import { ButtonGroup, Button, Radio, Modal } from 'react-bootstrap';
import i18n from './Localization';
import ImgHelp from './Images/help.gif';

class HelpButton extends Component {
  state: {
    show_modal: boolean
  };

  constructor() {
    super();
    this.state = {
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({show_modal: true});
  }

  close() {
    this.setState({show_modal: false});
  }

  print(printFn) {
    printFn(this.state.selected);
    this.close();
  }

  render(props) {
    return (
      <ButtonGroup>
      <Button className={"xwordjs-help-button"} title={i18n.t("helpTitle")} bsSize="xsmall" onClick={this.open}>
        <img src={ImgHelp}/>
      </Button>
      <Modal show={this.state.show_modal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>{i18n.t("helpTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="xwordjs-print-menu">
        <ul>
          <li dangerouslySetInnerHTML={{__html: i18n.t("help01")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help02")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help03")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help04")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help05")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help06")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help07")}} />
          <li dangerouslySetInnerHTML={{__html: i18n.t("help08")}} />
        </ul>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
      </ButtonGroup>);
  }
}

export default HelpButton;
